/* Líonoir Amsterdam, Shopify-thema. Geen afhankelijkheden. */
(function () {
  'use strict';
  var cfg = window.lionoir || { routes: {}, strings: {} };
  var S = cfg.strings || {};
  var lastFocus = null;

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  function money(cents) {
    try {
      var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
      return new Intl.NumberFormat(document.documentElement.lang || 'nl-NL', { style: 'currency', currency: cur }).format(cents / 100);
    } catch (e) {
      return '€ ' + (cents / 100).toFixed(2);
    }
  }

  /* Mobiel menu */
  var menuBtn = $('[data-menu-toggle]');
  var menuPanel = $('[data-mobile-nav]');
  if (menuBtn && menuPanel) {
    menuBtn.addEventListener('click', function () {
      var open = menuBtn.getAttribute('aria-expanded') === 'true';
      menuBtn.setAttribute('aria-expanded', String(!open));
      menuPanel.hidden = open;
    });
  }

  /* Winkelwagen-paneel */
  var drawer = $('[data-cart-drawer]');
  var scrim = $('[data-scrim]');

  function openDrawer() {
    if (!drawer) { window.location.href = cfg.routes.cart; return; }
    lastFocus = document.activeElement;
    drawer.classList.add('on');
    drawer.setAttribute('aria-hidden', 'false');
    if (scrim) scrim.classList.add('on');
    document.documentElement.style.overflow = 'hidden';
    var c = $('[data-drawer-close]', drawer);
    if (c) setTimeout(function () { c.focus(); }, 40);
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('on');
    drawer.setAttribute('aria-hidden', 'true');
    if (scrim) scrim.classList.remove('on');
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer && drawer.classList.contains('on')) closeDrawer();
  });
  if (scrim) scrim.addEventListener('click', closeDrawer);

  function setCount(n) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = !n;
    });
  }

  function refreshDrawer() {
    return fetch(cfg.routes.root + '?sections=cart-drawer', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-drawer'];
        if (!html || !drawer) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = $('[data-drawer-inner]', doc);
        var cur = $('[data-drawer-inner]', drawer);
        if (fresh && cur) cur.innerHTML = fresh.innerHTML;
      });
  }

  function refreshCount() {
    return fetch(cfg.routes.cartJson, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { setCount(cart.item_count); return cart; });
  }

  function changeLine(key, qty) {
    return fetch(cfg.routes.cartChange, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(function () {
      return Promise.all([refreshCount(), refreshDrawer()]);
    });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-cart-open]')) {
      if (cfg.drawer && drawer) { e.preventDefault(); refreshDrawer().then(openDrawer, openDrawer); }
      return;
    }
    if (t.closest('[data-drawer-close]')) { closeDrawer(); return; }
    var btn = t.closest('[data-line-action]');
    if (btn) {
      e.preventDefault();
      var key = btn.getAttribute('data-line-key');
      var qty = parseInt(btn.getAttribute('data-line-qty'), 10);
      var action = btn.getAttribute('data-line-action');
      if (action === 'inc') qty += 1;
      if (action === 'dec') qty -= 1;
      if (action === 'remove') qty = 0;
      btn.disabled = true;
      changeLine(key, Math.max(0, qty)).then(function () {
        if (document.body.classList.contains('template-cart')) window.location.reload();
      });
    }
  });

  /* Toevoegen aan winkelwagen (zonder paginavernieuwing) */
  $$('form[data-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      if (!cfg.drawer || !drawer) return;
      e.preventDefault();
      var submit = $('[type="submit"][name="add"]', form);
      var label = submit ? submit.textContent : '';
      if (submit) { submit.disabled = true; submit.textContent = S.adding || '…'; }
      var added = false;
      fetch(cfg.routes.cartAdd, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      }).then(function (r) { return r.json(); }).then(function (res) {
        if (res.status && res.status !== 200 && res.description) throw new Error(res.description);
        added = true;
        return Promise.all([refreshCount().catch(function () {}), refreshDrawer().catch(function () {})]);
      }).then(function () {
        lastFocus = submit;
        openDrawer();
      }).catch(function (err) {
        if (!added && !(err && err.message && /sold|stock|voorraad|available/i.test(err.message))) {
          form.submit();
          return;
        }
        var out = $('[data-form-error]', form);
        if (out) { out.textContent = err && err.message ? err.message : (S.error || ''); out.hidden = false; }
      }).then(function () {
        if (submit) { submit.disabled = false; submit.textContent = label; }
      });
    });
  });

  /* Productgalerij */
  $$('[data-gallery]').forEach(function (g) {
    var slides = $$('[data-slide]', g);
    var thumbs = $$('[data-thumb]', g);
    function show(i) {
      slides.forEach(function (s, n) { s.classList.toggle('is-active', n === i); });
      thumbs.forEach(function (t, n) { t.setAttribute('aria-current', String(n === i)); });
    }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { show(i); }); });
  });

  /* Hoeveelheid op productpagina */
  $$('[data-qty-input]').forEach(function (wrap) {
    var input = $('input', wrap);
    $$('[data-qty-step]', wrap).forEach(function (b) {
      b.addEventListener('click', function () {
        var v = parseInt(input.value, 10) || 1;
        v += parseInt(b.getAttribute('data-qty-step'), 10);
        input.value = Math.min(99, Math.max(1, v));
      });
    });
  });

  /* Varianten (voor producten met opties zoals maat) */
  $$('[data-product-root]').forEach(function (root) {
    var jsonEl = $('[data-product-json]', root);
    var metaEl = $('[data-variant-meta]', root);
    if (!jsonEl) return;
    var product = JSON.parse(jsonEl.textContent);
    var meta = metaEl ? JSON.parse(metaEl.textContent) : [];
    if (product.variants.length < 2) return;
    var form = $('form[data-product-form]', root);
    var idInput = $('[name="id"]', form);
    var addBtn = $('[name="add"]', form);
    var priceEl = $('[data-price]', root);
    var availEl = $('[data-avail]', root);
    var slides = $$('[data-slide]', root);
    var thumbs = $$('[data-thumb]', root);

    function selectedOptions() {
      var vals = [];
      $$('[data-option-index]', root).forEach(function (fs) {
        var checked = $('input:checked', fs);
        vals[parseInt(fs.getAttribute('data-option-index'), 10)] = checked ? checked.value : null;
      });
      return vals;
    }
    function find(vals) {
      return product.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === vals[i]; });
      });
    }
    function update() {
      var v = find(selectedOptions());
      var info = v && meta.find(function (m) { return m.id === v.id; });
      var state = !v || !v.available ? 'sold' : (info && info.preorder ? 'pre' : 'ok');
      if (v) {
        idInput.value = v.id;
        if (priceEl) {
          priceEl.innerHTML = money(v.price) + (v.compare_at_price > v.price ? '<s class="was">' + money(v.compare_at_price) + '</s>' : '');
        }
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url);
        } catch (e) { /* negeren */ }
        if (v.featured_media) {
          var idx = slides.findIndex(function (s) { return String(s.getAttribute('data-media-id')) === String(v.featured_media.id); });
          if (idx > -1 && thumbs[idx]) thumbs[idx].click();
        }
      }
      if (addBtn) {
        addBtn.disabled = state === 'sold';
        var price = v ? ' · ' + money(v.price) : '';
        addBtn.textContent = state === 'sold' ? (v ? S.soldOut : S.unavailable) : (state === 'pre' ? S.preorder : S.addToCart) + price;
      }
      if (availEl) {
        availEl.className = 'avail ' + state;
        var msg = state === 'sold' ? S.soldOutNote : (state === 'pre' ? S.preorderNote : S.inStock);
        $('span', availEl).textContent = v ? msg : S.unavailable;
      }
    }
    root.addEventListener('change', function (e) {
      if (e.target.closest('[data-option-index]')) update();
    });
  });

  /* Collectiefilter: direct toepassen */
  $$('[data-filter-form]').forEach(function (form) {
    form.addEventListener('change', function () { form.submit(); });
  });
  var sort = $('[data-sort]');
  if (sort) {
    sort.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* Land en valuta */
  $$('[data-localization-form] select').forEach(function (sel) {
    sel.addEventListener('change', function () { sel.form.submit(); });
  });

  setCount(parseInt(($('[data-cart-count]') || {}).textContent, 10) || 0);
})();
